<template>
  <div>
    <div id="box" class="text-center">
      <i class="fa fa-spinner spin fa-2x" v-if="fetching"></i>
      <table class="table table-hover ui-table" v-else>
        <thead>
          <tr>
            <th class="text-left">
              {{
                $t(
                  'school.academic.operation.profile_mgt.parentProfile.notificationKh'
                )
              }}
            </th>
            <th class="text-left">
              {{
                $t(
                  'school.academic.operation.profile_mgt.parentProfile.notificationEn'
                )
              }}
            </th>
            <th style="width:10px" class="text-right">
              <ts-checkbox
                v-model="allCheck"
                :checked="isAll"
                @change="checkedAll"
                >{{
                  $t(
                    'school.academic.operation.profile_mgt.parentProfile.approve'
                  )
                }}</ts-checkbox
              >
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(not, index) in notificationPrivacys" :key="index">
            <td class="text-left">{{ not.not_type_kh }}</td>
            <td class="text-left">{{ not.not_type }}</td>
            <td>
              <ts-checkbox
                v-model="model.not_type_list"
                :value="not.not_type_id"
              ></ts-checkbox>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  name: 'parentPrivacy',
  props: ['value', 'clear'],
  data() {
    return {
      model: {},
      allCheck: false,
      fetching: true
    }
  },
  created() {
    this.model = this.value
    this.setEditData()
  },
  computed: {
    ...mapState('parentProfile', ['notificationPrivacys', 'edit_data']),
    isAll() {
      return (this.allCheck =
        this.model.not_type_list.length == this.notificationPrivacys.length)
    }
  },
  methods: {
    ...mapActions('parentProfile', ['getNotificationType']),
    selectAll() {
      if (this.notificationPrivacys.length > 0) {
        this.model.not_type_list = []
        this.notificationPrivacys.map(el => {
          this.model.not_type_list.push(el.not_type_id)
        })
      }
    },
    checkedAll() {
      if (this.allCheck) {
        this.selectAll()
      } else {
        this.model.not_type_list = []
      }
    },
    async setEditData() {
      await this.getNotificationType().finally(() => {
        this.fetching = false
      })
      if (!_.isEmpty(this.edit_data)) {
        this.model.not_type_list = []
        this.edit_data.notifications.map(el => {
          this.model.not_type_list.push(el.not_type_id)
        })
      } else {
        this.selectAll()
      }
    }
  },
  watch: {
    clear: function(value) {
      if (value) {
        this.model = this.value
        this.selectAll()
      }
    }
  }
}
</script>

<style lang="css" scoped>
#box {
  max-height: 70vh;
  height: 60vh;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.table > thead > tr > th {
	  position: sticky;
		position: -webkit-sticky;
		top: 0;
		z-index: 999;
		/* padding: 7px; */
		border-bottom: none !important;
}
</style>
